import { render, staticRenderFns } from "./XueShuYanJiu.vue?vue&type=template&id=2aaf3944&scoped=true&"
import script from "./XueShuYanJiu.vue?vue&type=script&lang=js&"
export * from "./XueShuYanJiu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aaf3944",
  null
  
)

export default component.exports